var _path, _path2, _path3, _g, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g3, _path13, _g4, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g5, _path22, _g6, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g7, _path34, _g8, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g9, _path43, _g10, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g11, _path52, _g12, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g13, _path61, _g14, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _g15, _path70, _g16, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _g17, _path79, _g18, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _g19, _path95, _path96, _path97, _path98, _path99;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResponseBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 223,
    viewBox: "0 0 442 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M228.238 145.406C344.313 145.406 438.411 141.278 438.411 136.185C438.411 131.093 344.313 126.965 228.238 126.965C112.162 126.965 18.0645 131.093 18.0645 136.185C18.0645 141.278 112.162 145.406 228.238 145.406Z",
    fill: "#BCBEC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9091 81.0909L67.641 135.048C67.6365 135.971 66.8844 136.716 65.9609 136.711L56.4994 136.664C55.5763 136.66 54.8315 135.908 54.836 134.984L55.1041 81.0275C55.1086 80.1043 55.8607 79.3595 56.7841 79.364L66.2456 79.4109C67.1688 79.4156 67.9136 80.1678 67.9091 81.0909Z",
    fill: "#F7941D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 105,
    width: 59,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7708 105.748L92.7262 106.286C93.6493 106.295 94.3904 107.051 94.3813 107.974L94.2871 117.436C94.278 118.359 93.5221 119.1 92.5987 119.091L38.6434 118.553C37.7203 118.544 36.9792 117.788 36.9883 116.864L37.0825 107.403C37.0919 106.48 37.8477 105.739 38.7708 105.748Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.536 77.4957L61.2305 138.599L69.9314 138.642L70.2369 77.5392L61.536 77.4957Z",
    fill: "#F26522"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 79,
    width: 14,
    height: 58
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9101 81.0909L67.642 135.048C67.6375 135.971 66.8853 136.716 65.9619 136.711L56.5004 136.664C55.5773 136.66 54.8324 135.908 54.8369 134.984L55.1051 81.0275C55.1096 80.1043 55.8617 79.3595 56.7851 79.364L66.2466 79.4109C67.1697 79.4156 67.9146 80.1678 67.9101 81.0909Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.027 80.9668L56.7583 135.064C56.7516 136.441 55.6297 137.551 54.2526 137.545C52.8755 137.538 51.7648 136.416 51.7715 135.039L52.0402 80.9421C52.0469 79.565 53.1688 78.4543 54.546 78.461C55.9231 78.468 57.0338 79.5897 57.027 80.9668Z",
    fill: "#F9AB5D"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9006 124.682L54.874 130.006L67.6791 130.07L67.7057 124.746L54.9006 124.682Z",
    fill: "#434D6A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.303 124.714L61.2764 130.038L67.6787 130.07L67.7054 124.746L61.303 124.714Z",
    fill: "#2A2D4B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9016 124.683L54.875 130.008L56.797 130.017L56.8237 124.693L54.9016 124.683Z",
    fill: "#52607C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0916 86.0124L55.0649 91.3367L67.87 91.4007L67.8966 86.0764L55.0916 86.0124Z",
    fill: "#434D6A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4949 86.0443L61.4683 91.3685L67.8706 91.4005L67.8972 86.0763L61.4949 86.0443Z",
    fill: "#2A2D4B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0916 86.0124L55.0649 91.337L56.987 91.3466L57.0136 86.022L55.0916 86.0124Z",
    fill: "#52607C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7529 81.1548L80.4847 135.111C80.4803 136.035 79.7281 136.779 78.8047 136.775L69.3432 136.728C68.4198 136.724 67.6752 135.971 67.6797 135.048L67.9478 81.0913C67.9523 80.1679 68.7045 79.4233 69.6279 79.4278L79.0894 79.4747C80.0128 79.4795 80.7576 80.2316 80.7529 81.1548Z",
    fill: "#F7941D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 105,
    width: 59,
    height: 15
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6165 105.812L105.572 106.35C106.495 106.359 107.236 107.115 107.227 108.038L107.133 117.499C107.124 118.423 106.368 119.164 105.444 119.154L51.4891 118.617C50.5657 118.607 49.8249 117.852 49.834 116.928L49.9282 107.467C49.9376 106.543 50.6934 105.802 51.6165 105.812Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.3807 77.5596L74.0752 138.662L82.7761 138.706L83.0816 77.6031L74.3807 77.5596Z",
    fill: "#F26522"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 79,
    width: 14,
    height: 58
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7529 81.1547L80.4847 135.111C80.4803 136.035 79.7281 136.779 78.8047 136.775L69.3432 136.728C68.4198 136.723 67.6752 135.971 67.6797 135.048L67.9478 81.0912C67.9523 80.1678 68.7045 79.4233 69.6279 79.4278L79.0894 79.4746C80.0128 79.4794 80.7576 80.2316 80.7529 81.1547Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.8707 81.0306L69.6021 135.127C69.5953 136.505 68.4734 137.615 67.0963 137.608C65.7192 137.602 64.6085 136.48 64.6153 135.103L64.884 81.0059C64.8907 79.6288 66.0126 78.5181 67.3897 78.5249C68.7668 78.5319 69.8778 79.6538 69.8707 81.0306Z",
    fill: "#F9AB5D"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7434 124.747L67.7168 130.071L80.5218 130.135L80.5485 124.811L67.7434 124.747Z",
    fill: "#434D6A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1467 124.778L74.1201 130.103L80.5225 130.135L80.5491 124.81L74.1467 124.778Z",
    fill: "#2A2D4B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7449 124.749L67.7183 130.073L69.6403 130.083L69.6669 124.758L67.7449 124.749Z",
    fill: "#52607C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9343 86.0758L67.9077 91.4003L80.7128 91.4644L80.7394 86.1398L67.9343 86.0758Z",
    fill: "#434D6A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3367 86.1079L74.3101 91.4322L80.7124 91.4642L80.739 86.1399L74.3367 86.1079Z",
    fill: "#2A2D4B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9343 86.0758L67.9077 91.4004L69.8298 91.41L69.8564 86.0855L67.9343 86.0758Z",
    fill: "#52607C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4765 81.218L93.2084 135.175C93.2039 136.098 92.4517 136.843 91.5283 136.838L82.0668 136.791C81.1434 136.787 80.3988 136.035 80.4033 135.111L80.6715 81.1545C80.6759 80.2311 81.4281 79.4866 82.3515 79.491L91.813 79.5379C92.7364 79.5427 93.4813 80.2949 93.4765 81.218Z",
    fill: "#F7941D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 105,
    width: 58,
    height: 15
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3411 105.875L118.296 106.413C119.22 106.422 119.961 107.178 119.952 108.101L119.857 117.562C119.848 118.486 119.092 119.227 118.169 119.217L64.2137 118.68C63.2903 118.67 62.5495 117.915 62.5586 116.991L62.6528 107.53C62.6622 106.607 63.418 105.865 64.3411 105.875Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1063 77.6226L86.8008 138.725L95.5017 138.769L95.8072 77.6661L87.1063 77.6226Z",
    fill: "#F26522"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 79,
    width: 14,
    height: 58
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4765 81.218L93.2084 135.175C93.2039 136.098 92.4517 136.843 91.5283 136.838L82.0668 136.791C81.1434 136.787 80.3988 136.035 80.4033 135.111L80.6715 81.1545C80.6759 80.2311 81.4281 79.4866 82.3515 79.491L91.813 79.5379C92.7364 79.5427 93.4813 80.2949 93.4765 81.218Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.5944 81.0943L82.3257 135.191C82.319 136.568 81.1971 137.679 79.8199 137.672C78.4428 137.665 77.3322 136.543 77.3389 135.166L77.6076 81.0696C77.6143 79.6925 78.7362 78.5818 80.1133 78.5885C81.4905 78.5953 82.6014 79.7172 82.5944 81.0943Z",
    fill: "#F9AB5D"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4671 124.81L80.4404 130.134L93.2455 130.198L93.2721 124.874L80.4671 124.81Z",
    fill: "#434D6A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8704 124.842L86.8438 130.166L93.2461 130.198L93.2728 124.874L86.8704 124.842Z",
    fill: "#2A2D4B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4685 124.812L80.4419 130.136L82.364 130.146L82.3906 124.821L80.4685 124.812Z",
    fill: "#52607C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6565 86.1378L80.6299 91.4621L93.4349 91.5261L93.4615 86.2019L80.6565 86.1378Z",
    fill: "#434D6A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0598 86.1698L87.0332 91.4941L93.4356 91.5261L93.4622 86.2018L87.0598 86.1698Z",
    fill: "#2A2D4B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M80.658 86.1392L80.6313 91.4637L82.5534 91.4734L82.58 86.1488L80.658 86.1392Z",
    fill: "#52607C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M101.005 109.14H39.6289V88.1081L102.917 3.02335H136.377V82.3722H155.307V109.14H136.377V136.674H101.005V109.14ZM106.168 82.3722V44.132L78.0611 82.3722H106.168Z",
    fill: "#CED4DA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M189.915 131.225C180.609 125.68 173.439 117.682 168.405 107.228C163.368 96.7778 160.853 84.3496 160.853 69.944C160.853 55.5411 163.338 43.1126 168.309 32.6592C173.281 22.2088 180.385 14.1784 189.628 8.568C198.869 2.95989 209.801 0.154846 222.42 0.154846C235.039 0.154846 245.967 2.96017 255.212 8.568C264.452 14.1784 271.559 22.2088 276.53 32.6592C281.501 43.1126 283.987 55.5411 283.987 69.944C283.987 84.3496 281.469 96.7778 276.435 107.228C271.397 117.682 264.227 125.68 254.925 131.225C245.618 136.77 234.782 139.542 222.42 139.542C210.054 139.542 199.219 136.77 189.915 131.225ZM242.305 97.8596C247.02 91.2329 249.38 82.0555 249.38 70.3263C249.38 58.4722 247.052 49.1357 242.4 42.315C237.746 35.4979 231.086 32.0859 222.42 32.0859C213.75 32.0859 207.091 35.4976 202.439 42.315C197.784 49.1357 195.46 58.4722 195.46 70.3263C195.46 82.0555 197.817 91.2332 202.535 97.8596C207.249 104.489 213.879 107.802 222.42 107.802C230.958 107.802 237.587 104.489 242.305 97.8596Z",
    fill: "#CED4DA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M350.908 109.14H289.532V88.1081L352.82 3.02335H386.28V82.3722H405.209V109.14H386.28V136.674H350.908V109.14ZM356.071 82.3722V44.132L327.964 82.3722H356.071Z",
    fill: "#CED4DA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M263.626 114.519L210.52 115.11C209.612 115.12 208.867 114.392 208.857 113.483L208.753 104.171C208.743 103.262 209.471 102.517 210.38 102.507L263.486 101.916C264.395 101.906 265.14 102.634 265.15 103.543L265.253 112.855C265.264 113.764 264.535 114.509 263.626 114.519Z",
    fill: "#F7941D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 208,
    y: 101,
    width: 58,
    height: 15
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M263.62 114.229L210.526 115.409C209.617 115.429 208.865 114.71 208.844 113.801L208.637 104.491C208.617 103.582 209.337 102.829 210.246 102.809L263.34 101.629C264.249 101.608 265.001 102.329 265.022 103.237L265.229 112.547C265.249 113.456 264.529 114.208 263.62 114.229Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.043 108.184L206.907 108.852L207.002 117.415L267.138 116.748L267.043 108.184Z",
    fill: "#F26522"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 208,
    y: 101,
    width: 58,
    height: 15
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M263.626 114.519L210.52 115.11C209.612 115.12 208.867 114.392 208.857 113.483L208.753 104.171C208.743 103.262 209.471 102.517 210.38 102.507L263.486 101.916C264.395 101.906 265.14 102.634 265.15 103.543L265.253 112.855C265.264 113.764 264.535 114.509 263.626 114.519Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.577 103.807L210.333 104.399C208.978 104.415 207.867 103.328 207.852 101.972C207.837 100.617 208.923 99.5063 210.279 99.4912L263.522 98.8985C264.878 98.8833 265.989 99.9698 266.004 101.325C266.019 102.681 264.932 103.791 263.577 103.807Z",
    fill: "#F9AB5D"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M220.5 102.399L215.26 102.457L215.4 115.06L220.64 115.001L220.5 102.399Z",
    fill: "#434D6A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M220.57 108.7L215.33 108.758L215.4 115.059L220.64 115.001L220.57 108.7Z",
    fill: "#2A2D4B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M220.5 102.399L215.26 102.457L215.281 104.349L220.521 104.29L220.5 102.399Z",
    fill: "#52607C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M258.558 101.977L253.318 102.035L253.458 114.637L258.698 114.579L258.558 101.977Z",
    fill: "#434D6A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M258.628 108.278L253.388 108.336L253.458 114.637L258.698 114.579L258.628 108.278Z",
    fill: "#2A2D4B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M258.558 101.977L253.318 102.035L253.339 103.926L258.579 103.868L258.558 101.977Z",
    fill: "#52607C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M263.767 127.158L210.661 127.75C209.753 127.76 209.008 127.031 208.998 126.123L208.894 116.811C208.884 115.902 209.613 115.157 210.521 115.147L263.627 114.556C264.536 114.545 265.281 115.274 265.291 116.183L265.394 125.495C265.405 126.404 264.676 127.148 263.767 127.158Z",
    fill: "#F7941D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 208,
    y: 114,
    width: 58,
    height: 15
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M263.76 126.868L210.666 128.049C209.758 128.069 209.005 127.349 208.985 126.44L208.778 117.13C208.757 116.222 209.478 115.469 210.386 115.449L263.48 114.268C264.389 114.248 265.141 114.968 265.162 115.876L265.369 125.186C265.389 126.095 264.669 126.848 263.76 126.868Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.182 120.824L207.046 121.491L207.141 130.055L267.277 129.387L267.182 120.824Z",
    fill: "#F26522"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 208,
    y: 114,
    width: 58,
    height: 14
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M263.767 127.158L210.661 127.75C209.752 127.76 209.007 127.031 208.997 126.123L208.893 116.811C208.883 115.902 209.612 115.157 210.52 115.147L263.626 114.556C264.535 114.545 265.28 115.274 265.29 116.183L265.393 125.495C265.404 126.404 264.675 127.148 263.767 127.158Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.717 116.446L210.473 117.039C209.118 117.054 208.007 115.968 207.992 114.612C207.977 113.257 209.063 112.146 210.419 112.131L263.663 111.538C265.018 111.523 266.129 112.61 266.144 113.965C266.159 115.32 265.073 116.431 263.717 116.446Z",
    fill: "#F9AB5D"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M220.639 115.038L215.399 115.097L215.539 127.699L220.779 127.641L220.639 115.038Z",
    fill: "#434D6A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M220.709 121.34L215.469 121.398L215.539 127.699L220.779 127.641L220.709 121.34Z",
    fill: "#2A2D4B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M220.639 115.038L215.399 115.097L215.42 116.988L220.66 116.93L220.639 115.038Z",
    fill: "#52607C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M258.698 114.616L253.458 114.674L253.597 127.277L258.838 127.219L258.698 114.616Z",
    fill: "#434D6A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M258.768 120.917L253.528 120.975L253.598 127.277L258.838 127.218L258.768 120.917Z",
    fill: "#2A2D4B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M258.698 114.616L253.458 114.674L253.479 116.566L258.719 116.508L258.698 114.616Z",
    fill: "#52607C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M263.905 139.68L210.799 140.271C209.89 140.281 209.146 139.553 209.135 138.644L209.032 129.332C209.022 128.423 209.75 127.679 210.659 127.668L263.765 127.077C264.674 127.067 265.418 127.796 265.429 128.704L265.532 138.016C265.542 138.925 264.814 139.67 263.905 139.68Z",
    fill: "#F7941D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 208,
    y: 126,
    width: 58,
    height: 15
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M263.897 139.389L210.803 140.57C209.894 140.59 209.141 139.87 209.121 138.961L208.914 129.651C208.894 128.743 209.614 127.99 210.523 127.97L263.617 126.789C264.525 126.769 265.278 127.489 265.298 128.397L265.505 137.707C265.526 138.616 264.806 139.369 263.897 139.389Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.321 133.345L207.185 134.012L207.28 142.576L267.416 141.908L267.321 133.345Z",
    fill: "#F26522"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 209,
    y: 127,
    width: 57,
    height: 14
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M263.904 139.68L210.798 140.271C209.889 140.281 209.145 139.553 209.134 138.644L209.031 129.332C209.021 128.423 209.749 127.678 210.658 127.668L263.764 127.077C264.673 127.067 265.417 127.795 265.428 128.704L265.531 138.016C265.541 138.925 264.813 139.67 263.904 139.68Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.854 128.968L210.61 129.561C209.255 129.576 208.144 128.49 208.129 127.134C208.114 125.779 209.2 124.668 210.556 124.653L263.799 124.06C265.155 124.045 266.266 125.131 266.281 126.487C266.296 127.842 265.209 128.953 263.854 128.968Z",
    fill: "#F9AB5D"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M220.779 127.56L215.539 127.618L215.679 140.22L220.919 140.162L220.779 127.56Z",
    fill: "#434D6A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M220.849 133.861L215.609 133.919L215.679 140.22L220.919 140.162L220.849 133.861Z",
    fill: "#2A2D4B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M220.779 127.56L215.539 127.618L215.56 129.509L220.8 129.451L220.779 127.56Z",
    fill: "#52607C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M258.838 127.137L253.598 127.195L253.738 139.798L258.978 139.739L258.838 127.137Z",
    fill: "#434D6A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M258.908 133.438L253.668 133.497L253.738 139.798L258.978 139.74L258.908 133.438Z",
    fill: "#2A2D4B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M258.838 127.137L253.598 127.195L253.619 129.087L258.859 129.029L258.838 127.137Z",
    fill: "#52607C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M372.845 81.5922L373.436 134.698C373.447 135.607 372.718 136.352 371.809 136.362L362.497 136.466C361.589 136.476 360.844 135.747 360.834 134.839L360.242 81.7326C360.232 80.8238 360.961 80.079 361.869 80.0688L371.181 79.9653C372.09 79.9549 372.835 80.6834 372.845 81.5922Z",
    fill: "#F7941D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 342,
    y: 105,
    width: 58,
    height: 15
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M344.534 106.773L397.629 105.593C398.537 105.572 399.29 106.293 399.31 107.201L399.517 116.511C399.537 117.42 398.817 118.173 397.909 118.193L344.815 119.373C343.906 119.394 343.153 118.673 343.133 117.765L342.926 108.455C342.906 107.547 343.626 106.794 344.534 106.773Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.516 78.1817L367.184 138.318L375.747 138.223L375.079 78.0866L366.516 78.1817Z",
    fill: "#F26522"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 360,
    y: 79,
    width: 14,
    height: 58
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M372.847 81.5923L373.438 134.698C373.448 135.607 372.719 136.352 371.811 136.362L362.499 136.466C361.59 136.476 360.845 135.747 360.835 134.839L360.244 81.7327C360.234 80.8239 360.962 80.079 361.871 80.0689L371.183 79.9653C372.091 79.9549 372.836 80.6835 372.847 81.5923Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.134 81.6425L362.727 134.886C362.742 136.242 361.655 137.353 360.3 137.368C358.945 137.383 357.834 136.296 357.818 134.941L357.226 81.697C357.211 80.3418 358.297 79.2308 359.653 79.2157C361.008 79.2008 362.119 80.287 362.134 81.6425Z",
    fill: "#F9AB5D"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M360.733 124.726L360.791 129.966L373.393 129.826L373.335 124.586L360.733 124.726Z",
    fill: "#434D6A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M367.034 124.656L367.092 129.896L373.393 129.826L373.335 124.586L367.034 124.656Z",
    fill: "#2A2D4B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M360.729 124.725L360.788 129.965L362.679 129.944L362.621 124.704L360.729 124.725Z",
    fill: "#52607C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M360.307 86.6635L360.365 91.9036L372.968 91.7637L372.91 86.5236L360.307 86.6635Z",
    fill: "#434D6A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M366.608 86.5937L366.667 91.8338L372.968 91.7639L372.91 86.5238L366.608 86.5937Z",
    fill: "#2A2D4B"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M360.31 86.6648L360.369 91.9048L362.26 91.8838L362.202 86.6438L360.31 86.6648Z",
    fill: "#52607C"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M385.484 81.4511L386.075 134.557C386.085 135.466 385.357 136.211 384.448 136.221L375.136 136.324C374.227 136.335 373.482 135.606 373.472 134.697L372.881 81.5914C372.871 80.6826 373.599 79.9378 374.508 79.9277L383.82 79.8241C384.729 79.814 385.474 80.5425 385.484 81.4511Z",
    fill: "#F7941D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 355,
    y: 105,
    width: 58,
    height: 15
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M357.172 106.633L410.266 105.452C411.175 105.432 411.928 106.152 411.948 107.06L412.155 116.37C412.175 117.279 411.455 118.032 410.546 118.052L357.452 119.233C356.544 119.253 355.791 118.533 355.771 117.624L355.564 108.314C355.544 107.406 356.264 106.653 357.172 106.633Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.154 78.0409L379.821 138.177L388.385 138.082L387.717 77.9459L379.154 78.0409Z",
    fill: "#F26522"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 372,
    y: 79,
    width: 15,
    height: 58
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M385.485 81.4511L386.076 134.557C386.086 135.466 385.358 136.211 384.449 136.221L375.137 136.324C374.228 136.335 373.483 135.606 373.473 134.697L372.882 81.5914C372.872 80.6826 373.6 79.9378 374.509 79.9277L383.821 79.8241C384.73 79.814 385.475 80.5425 385.485 81.4511Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.773 81.5016L375.365 134.745C375.38 136.101 374.294 137.212 372.938 137.227C371.583 137.242 370.472 136.155 370.457 134.8L369.864 81.5561C369.849 80.2006 370.936 79.0896 372.291 79.0747C373.646 79.0596 374.757 80.1461 374.773 81.5016Z",
    fill: "#F9AB5D"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M373.369 124.584L373.427 129.824L386.03 129.684L385.972 124.444L373.369 124.584Z",
    fill: "#434D6A"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M379.671 124.514L379.729 129.755L386.03 129.685L385.972 124.444L379.671 124.514Z",
    fill: "#2A2D4B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M373.366 124.583L373.424 129.823L375.315 129.802L375.257 124.562L373.366 124.583Z",
    fill: "#52607C"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M372.949 86.5234L373.007 91.7635L385.61 91.6236L385.552 86.3835L372.949 86.5234Z",
    fill: "#434D6A"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M379.25 86.4533L379.308 91.6934L385.609 91.6234L385.551 86.3833L379.25 86.4533Z",
    fill: "#2A2D4B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M372.948 86.5232L373.006 91.7633L374.898 91.7423L374.84 86.5022L372.948 86.5232Z",
    fill: "#52607C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M398.005 81.312L398.597 134.418C398.607 135.327 397.878 136.072 396.97 136.082L387.657 136.185C386.749 136.195 386.004 135.467 385.994 134.558L385.402 81.4524C385.392 80.5435 386.121 79.7987 387.029 79.7886L396.342 79.685C397.25 79.6749 397.995 80.4032 398.005 81.312Z",
    fill: "#F7941D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 368,
    y: 105,
    width: 57,
    height: 15
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M369.694 106.494L422.788 105.313C423.696 105.293 424.449 106.014 424.469 106.922L424.676 116.232C424.697 117.14 423.976 117.893 423.068 117.914L369.974 119.094C369.065 119.114 368.312 118.394 368.292 117.486L368.085 108.176C368.065 107.267 368.785 106.514 369.694 106.494Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.675 77.9023L392.343 138.039L400.906 137.944L400.239 77.8072L391.675 77.9023Z",
    fill: "#F26522"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 385,
    y: 79,
    width: 14,
    height: 58
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M398.004 81.312L398.596 134.418C398.606 135.327 397.877 136.072 396.969 136.082L387.657 136.185C386.748 136.195 386.003 135.467 385.993 134.558L385.401 81.4524C385.391 80.5435 386.12 79.7987 387.028 79.7886L396.341 79.685C397.249 79.6749 397.994 80.4032 398.004 81.312Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.292 81.3622L387.885 134.606C387.9 135.961 386.813 137.072 385.458 137.087C384.102 137.103 382.992 136.016 382.977 134.66L382.384 81.4167C382.369 80.0615 383.455 78.9505 384.811 78.9353C386.166 78.9205 387.277 80.007 387.292 81.3622Z",
    fill: "#F9AB5D"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M385.888 124.444L385.946 129.684L398.549 129.544L398.491 124.304L385.888 124.444Z",
    fill: "#434D6A"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M392.189 124.374L392.247 129.614L398.548 129.544L398.49 124.304L392.189 124.374Z",
    fill: "#2A2D4B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M385.894 124.447L385.953 129.687L387.844 129.666L387.786 124.426L385.894 124.447Z",
    fill: "#52607C"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M385.468 86.3843L385.526 91.6244L398.128 91.4845L398.07 86.2444L385.468 86.3843Z",
    fill: "#434D6A"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M391.769 86.3145L391.827 91.5546L398.128 91.4846L398.07 86.2445L391.769 86.3145Z",
    fill: "#2A2D4B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M385.467 86.3844L385.525 91.6245L387.416 91.6035L387.358 86.3634L385.467 86.3844Z",
    fill: "#52607C"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0801 208.276C12.5548 208.276 3.17832 198.9 3.17832 187.374C3.17832 175.849 12.5548 166.473 24.0801 166.473H270.178C278.074 166.473 284.498 160.049 284.498 152.153V150.754H305.704C313.392 150.754 319.647 144.5 319.647 136.812V79.2145C319.647 71.7099 325.753 65.604 333.258 65.604H373.324C375.967 65.604 378.117 67.754 378.117 70.397V70.6219H372.227C368.738 70.6219 365.9 73.4601 365.9 76.9488V80.0107H368.202V76.9488C368.202 74.7291 370.008 72.9233 372.227 72.9233H378.117V80.0107H380.419V72.9233H386.613C388.833 72.9233 390.638 74.7291 390.638 76.9488V79.7364H392.94V76.9488C392.94 73.4601 390.102 70.6219 386.613 70.6219H380.419V70.397C380.419 66.4853 377.236 63.3026 373.324 63.3026H333.258C324.484 63.3026 317.346 70.4406 317.346 79.2145V136.812C317.346 143.231 312.124 148.453 305.705 148.453H284.498V131.255C284.498 125.728 280.601 121.097 275.411 119.958V113.257C275.411 109.615 272.448 106.651 268.805 106.651H265.201V108.953H268.805C271.179 108.953 273.11 110.884 273.11 113.257V119.692C273.05 119.691 272.991 119.688 272.931 119.688H265.342V121.989H272.931C272.991 121.989 273.05 121.992 273.11 121.993V128.948C273.11 130.764 271.633 132.241 269.817 132.241H265.482V134.542H269.817C272.902 134.542 275.412 132.032 275.412 128.947V122.329C279.32 123.416 282.197 127.004 282.197 131.254V152.153C282.197 158.779 276.806 164.17 270.179 164.17H118.044V87.8932C118.044 79.8619 111.51 73.3279 103.479 73.3279H91.8309C88.4096 73.3279 85.6262 76.1113 85.6262 79.5326H87.9275C87.9275 77.3803 89.6786 75.6295 91.8306 75.6295H103.478C110.241 75.6295 115.742 81.1309 115.742 87.8932V164.171H24.0801C11.2857 164.171 0.876953 174.58 0.876953 187.375C0.876953 200.169 11.286 210.578 24.0801 210.578H432.051V208.276L24.0801 208.276Z",
    fill: "#2A2D4B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M425.408 173.587H423.024V187.297H425.408V173.587Z",
    fill: "#434D6A"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M429.713 187.297H418.718V189.382H429.713V187.297Z",
    fill: "#2A2D4B"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M429.57 171.502H418.574V173.586H429.57V171.502Z",
    fill: "#2A2D4B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M440.08 191.468H408.366C407.79 191.468 407.323 191.001 407.323 190.425C407.323 189.848 407.79 189.382 408.366 189.382H440.08C440.656 189.382 441.123 189.848 441.123 190.425C441.123 191.001 440.656 191.468 440.08 191.468Z",
    fill: "#DA927E"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M440.08 222.845H408.366C407.79 222.845 407.323 222.378 407.323 221.802C407.323 221.226 407.79 220.759 408.366 220.759H440.08C440.656 220.759 441.123 221.226 441.123 221.802C441.123 222.378 440.656 222.845 440.08 222.845Z",
    fill: "#DA927E"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M438.718 191.467H409.427V220.759H438.718V191.467Z",
    fill: "#995042"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M433.731 171.502H414.415C413.849 171.502 413.39 171.043 413.39 170.476V166.758C413.39 166.192 413.849 165.733 414.415 165.733H433.731C434.297 165.733 434.757 166.192 434.757 166.758V170.476C434.756 171.043 434.297 171.502 433.731 171.502Z",
    fill: "#F26522"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_20698_4826",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 413,
    y: 165,
    width: 22,
    height: 7
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M433.731 171.502H414.415C413.849 171.502 413.39 171.043 413.39 170.476V166.758C413.39 166.192 413.849 165.733 414.415 165.733H433.731C434.297 165.733 434.757 166.192 434.757 166.758V170.476C434.756 171.043 434.297 171.502 433.731 171.502Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_20698_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.584 167.796H413.809C412.823 167.796 412.023 166.996 412.023 166.01C412.023 165.024 412.823 164.224 413.809 164.224H435.584C436.57 164.224 437.37 165.024 437.37 166.01C437.37 166.996 436.57 167.796 435.584 167.796Z",
    fill: "#F7941D"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M412.398 191.467V194.199H430.997V218.51H412.398V220.759H438.719V191.467H412.398Z",
    fill: "#754436"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M415.186 191.467H413.919V220.759H415.186V191.467Z",
    fill: "#DA927E"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M421.524 191.467H420.257V220.759H421.524V191.467Z",
    fill: "#DA927E"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M428.037 191.467H426.771V220.759H428.037V191.467Z",
    fill: "#DA927E"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M434.373 191.467H433.107V220.759H434.373V191.467Z",
    fill: "#DA927E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponseBad);
export default __webpack_public_path__ + "static/media/responseBad.7a219c75094a5d7c9c941d5a4c2fff4d.svg";
export { ForwardRef as ReactComponent };